import { Serials } from "./../../../claims/out-pat-claims/out-pat-claims.service";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserSessionService } from "../../../app-user-session.service";
import { PatBillService } from "../../../billing/pat-bill/pat-bill.service";
import { ToastService } from "../../../blocks";
import { RegPatService } from "../../../pricing/reg-pat-service/reg-pat-service";

@Component({
  selector: "app-discount-services-request",
  templateUrl: "./discount-services-request.component.html",
  styleUrls: ["./discount-services-request.component.css"],
})
export class DiscountServicesRequestComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  serviceDiscount = <RegPatService>{};
  regPatServiceSerial: number;
  maxDiscountVal: number;
  remainingPrice: number;
  serial: number;
  isCompletionService: number;

  serviceNameAr: string;
  serviceNameEn: string;
  constructor(
    public translate: TranslateService,
    private _userSessionService: UserSessionService,
    private _toastService: ToastService,
    private _patBillService: PatBillService,
    private _toaster: ToastService
  ) { }

  ngOnInit() {
    this._userSessionService
      .subscribeToKey$("DiscountServicesRequest")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.serial = keys.value.regPatServiceSerial;
          this.serviceNameEn = keys.value.serviceNameEn;
          this.serviceNameAr = keys.value.serviceNameAr;
          this.isCompletionService = keys.value.isCompletionService;
          this.remainingPrice = keys.value.remainingPrice;
          this.getDisContServiceRequest(keys.value);
        }
      });
  }

  onDiscountValueChange(value: any) {
    if (
      this.serviceDiscount.percentOrValue == 1 &&
      +value > this.maxDiscountVal
    ) {
      this._toastService.activateMsg("UI428");
      return -1;
    }
    if (
      this.serviceDiscount.percentOrValue == 2 &&
      +value > (this.maxDiscountVal * this.serviceDiscount.patPrice) / 100
    ) {
      this._toastService.activateMsg("UI428");
      return -1;
    }
  }
  save(serviceDiscount) {
    if (this.isCompletionService == 1) {
      this._toaster.activateMsg(this.translate.currentLang == 'ar' ? 'تم الانتهاء من الخدمة' : 'The Service Has Been Completion');
      return;
    }
    else if (this.remainingPrice > 0 && serviceDiscount.discountValue > this.remainingPrice) {
     // serviceDiscount.discountValue = this.remainingPrice;
      this._toaster.activateMsg(this.translate.currentLang == 'ar' ? ' المتبقي أصغر من الخصم ' : 'The Remaining Value Less Than Discount ');
      return;
    }
    serviceDiscount.serial = this.serial;
    this._patBillService
      .updateDiscountService(serviceDiscount)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((c) => {
        if (c && c.returnFlag == true) {
        }
      });
  }

  getDisContServiceRequest(data: any) {
    data.serial = this.serial;
    this._patBillService
      .getDisContServiceRequest(data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res && res.data && res.data.length > 0) {
          this.serviceDiscount = res.data[0];
        } else {
          this.serviceDiscount = {};
        }
      });
  }
}
